import { A11yModule } from '@angular/cdk/a11y';
import { ComponentType } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { Subject } from 'rxjs';

import { VerticalOffsetDirective } from '../private/vertical-offset.directive';

import { DIALOG_CONFIG } from './tokens';

@Component({
  selector: 'plugins-dialog',
  standalone: true,
  imports: [CommonModule, A11yModule, VerticalOffsetDirective],
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent implements OnDestroy {
  @ViewChild('dialog', { static: true })
  dialogRef!: ElementRef<HTMLDialogElement>;

  @ViewChild('vcr', { read: ViewContainerRef, static: true })
  vcr!: ViewContainerRef;

  readonly config = inject(DIALOG_CONFIG);

  #closed$ = new Subject<unknown>();
  closed$ = this.#closed$.asObservable();
  #close?: () => void;

  open<T>(component: ComponentType<T>, close: () => void) {
    this.#close = close;
    const content = this.vcr.createComponent(component);
    this.config.modal
      ? this.dialogRef.nativeElement.showModal()
      : this.dialogRef.nativeElement.show();
    return content;
  }

  close(val?: unknown) {
    this.#closed$.next(val);
    this.dialogRef.nativeElement.close();
    this.vcr.remove();
    this.#close?.();
  }

  ngOnDestroy(): void {
    this.#closed$.complete();
  }
}
